// =============================================
// VITALITY SUPPLEMENT STACK BUILDER
// supplement-stack.js
// Architecture: 5 Goals → 4 Symptoms → 3 product slots
// Each slot: 1 primary + 2-3 swaps (validated non-overlapping)
// =============================================

// =============================================
// PRODUCT CATALOG — all supplement products
// =============================================
const VSS_PRODUCTS = {
  'nad':                                      { name:'NAD+ Cellular Energy Support',              price:59.99 },
  'alpha-energy':                             { name:'Alpha Energy',                               price:40.90 },
  'energy-strips':                            { name:'Energy Strips',                              price:36.50 },
  'methylene-blue-drops':                     { name:'Methylene Blue Drops',                       price:59.00 },
  'coq10-ubiquinone':                         { name:'CoQ10 Ubiquinone',                           price:28.90 },
  'beetroot-powder':                          { name:'Beetroot Powder',                            price:35.90 },
  'beetroot':                                 { name:'Beetroot',                                   price:20.90 },
  'vitamin-d3-2-000-iu':                      { name:'Vitamin D3 2,000 IU',                        price:19.90 },
  'complete-multivitamin':                    { name:'Complete Multivitamin',                      price:32.90 },
  'omega-3-epa-180mg-dha-120mg':              { name:'Omega-3 EPA + DHA',                          price:24.90 },
  'focus-powder-sour-grape':                  { name:'Focus Powder',                               price:39.90 },
  'brain-focus-formula':                      { name:'Brain & Focus Formula',                      price:39.90 },
  'cognitive-support':                        { name:'Cognitive Support',                          price:29.90 },
  'cognitive-relax-strips':                   { name:'Cognitive Relax Strips',                     price:32.90 },
  'ashwagandha-plus':                         { name:'Ashwagandha Plus',                           price:29.50 },
  'ashwagandha':                              { name:'Ashwagandha',                                price:23.90 },
  'lions-mane-mushroom':                      { name:"Lion's Mane Mushroom",                       price:33.90 },
  'mushroom-complex-10-x':                    { name:'Mushroom Complex 10X',                       price:35.90 },
  'fermented-mushroom-blend':                 { name:'Fermented Mushroom Blend',                   price:51.90 },
  'ginkgo-biloba-ginseng':                    { name:'Ginkgo Biloba + Ginseng',                    price:29.90 },
  '5-htp':                                    { name:'5-HTP',                                      price:19.90 },
  'sleep-formula':                            { name:'Sleep Formula',                              price:29.90 },
  'sleep-support':                            { name:'Sleep Support',                              price:29.90 },
  'magnesium-glycinate':                      { name:'Magnesium Glycinate',                        price:26.90 },
  'l-glutamine-powder':                       { name:'L-Glutamine Powder',                         price:26.90 },
  'creatine-monohydrate':                     { name:'Creatine Monohydrate',                       price:33.90 },
  'creatine-hydration-powder':                { name:'Creatine Hydration Powder',                  price:42.00 },
  'energy-powder-fruit-punch':                { name:'Pre-Workout Energy Powder',                  price:34.99 },
  'nitric-shock-pre-workout-powder-fruit-punch': { name:'Nitric Shock Pre-Workout',                price:38.90 },
  'bcaa-shock-powder-fruit-punch':            { name:'BCAA Shock Powder',                          price:33.90 },
  'bcaa-post-workout-powder-honeydew-watermelon': { name:'BCAA Post Workout Powder',               price:35.90 },
  'advanced-100-whey-protein-isolate-chocolate':  { name:'Whey Protein Isolate',                   price:49.90 },
  'plant-protein-chocolate':                  { name:'Plant Protein',                              price:44.90 },
  'l-citrulline-l-arginine-stack':            { name:'L-Citrulline & L-Arginine Stack',            price:39.99 },
  'nitric-oxide':                             { name:'Nitric Oxide',                               price:39.99 },
  'hydration-powder-lemonade':                { name:'Hydration Powder',                           price:34.99 },
  'colostrum-capsules':                       { name:'Colostrum Capsules',                         price:35.00 },
  'colostrum-powder':                         { name:'Colostrum Powder',                           price:39.95 },
  'berberine':                                { name:'Berberine',                                  price:39.90 },
  'fat-burner-with-mct':                      { name:'Fat Burner with MCT',                        price:33.90 },
  'normal-blood-sugar-support':               { name:'Normal Blood Sugar Support',                 price:29.90 },
  'greens-superfood':                         { name:'Greens Superfood',                           price:35.90 },
  'fruits-and-veggies':                       { name:'Fruits and Veggies',                         price:49.95 },
  'moringa-pure':                             { name:'Moringa Pure',                               price:26.90 },
  'resveratrol-50-600mg':                     { name:'Resveratrol 50% 600mg',                      price:25.90 },
  'platinum-turmeric':                        { name:'Platinum Turmeric',                          price:25.90 },
  'sea-moss':                                 { name:'Sea Moss',                                   price:25.90 },
  'grass-fed-hydrolyzed-collagen-peptides':   { name:'Grass-Fed Collagen Peptides',                price:33.90 },
  'grass-fed-collagen-peptides-powder-chocolate': { name:'Grass-Fed Collagen Peptides Powder',     price:35.90 },
  'grass-fed-collagen-creamer-vanilla':       { name:'Grass-Fed Collagen Creamer',                 price:35.90 },
  'beauty-collagen-strips':                   { name:'Beauty + Collagen Strips',                   price:28.90 },
  'hair-skin-and-nails-essentials':           { name:'Hair, Skin & Nails Essentials',              price:32.90 },
  'hair-skin-and-nails-strips':               { name:'Hair, Skin & Nails Strips',                  price:32.90 },
  'mens-vitality':                            { name:"Men's Vitality",                             price:36.90 },
  'womens-vitality-formula':                  { name:"Women's Vitality Formula",                   price:30.50 },
  'maca-plus':                                { name:'Maca Plus',                                  price:32.90 },
  'horny-goat-weed-blend':                    { name:'Horny Goat Weed Blend',                      price:33.90 },
};

// =============================================
// STACK DATA — 5 goals × 4 symptoms × 3 slots
// Each slot: { primary: handle, swaps: [handle, handle, handle] }
// Swap pools validated — no overlap within same stack
// =============================================
const VSS_STACKS = {
  energy: {
    label: 'Energy & Vitality',
    icon: '⚡',
    color: 'rgba(255,200,60,.6)',
    intro: 'Targeted compounds to restore and sustain your cellular energy — from the mitochondria up.',
    symptoms: [
      {
        label: 'I crash every afternoon',
        slots: [
          { primary: 'energy-strips',       swaps: ['focus-powder-sour-grape', 'cognitive-support'] },
          { primary: 'coq10-ubiquinone',    swaps: ['beetroot-powder', 'alpha-energy'] },
          { primary: 'magnesium-glycinate', swaps: ['vitamin-d3-2-000-iu', 'omega-3-epa-180mg-dha-120mg'] },
        ]
      },
      {
        label: 'I wake up exhausted no matter how much I sleep',
        slots: [
          { primary: 'nad',                 swaps: ['methylene-blue-drops', 'alpha-energy'] },
          { primary: 'magnesium-glycinate', swaps: ['sleep-support', 'ashwagandha'] },
          { primary: 'vitamin-d3-2-000-iu', swaps: ['complete-multivitamin', 'omega-3-epa-180mg-dha-120mg'] },
        ]
      },
      {
        label: 'I need clean energy without the jitters',
        slots: [
          { primary: 'energy-strips',       swaps: ['cognitive-relax-strips', 'focus-powder-sour-grape'] },
          { primary: 'ashwagandha',         swaps: ['ashwagandha-plus', 'cognitive-support'] },
          { primary: 'coq10-ubiquinone',    swaps: ['beetroot-powder', 'beetroot'] },
        ]
      },
      {
        label: 'I want to support cellular energy long-term',
        slots: [
          { primary: 'nad',                 swaps: ['methylene-blue-drops', 'sea-moss'] },
          { primary: 'coq10-ubiquinone',    swaps: ['alpha-energy', 'beetroot-powder'] },
          { primary: 'resveratrol-50-600mg',swaps: ['omega-3-epa-180mg-dha-120mg', 'platinum-turmeric'] },
        ]
      },
    ]
  },

  mind: {
    label: 'Mind & Focus',
    icon: '🧠',
    color: 'rgba(120,160,255,.6)',
    intro: 'Nootropics and adaptogens to sharpen cognition, clear the fog, and protect your brain long-term.',
    symptoms: [
      {
        label: 'I have brain fog and can\'t concentrate',
        slots: [
          { primary: 'focus-powder-sour-grape', swaps: ['brain-focus-formula', 'cognitive-support'] },
          { primary: 'lions-mane-mushroom',     swaps: ['mushroom-complex-10-x', 'ginkgo-biloba-ginseng'] },
          { primary: 'energy-strips',           swaps: ['cognitive-relax-strips', 'ashwagandha-plus'] },
        ]
      },
      {
        label: 'I feel anxious or mentally overloaded',
        slots: [
          { primary: 'ashwagandha-plus',    swaps: ['ashwagandha', 'cognitive-relax-strips'] },
          { primary: 'magnesium-glycinate', swaps: ['5-htp', 'sleep-support'] },
          { primary: 'lions-mane-mushroom', swaps: ['cognitive-support', 'brain-focus-formula'] },
        ]
      },
      {
        label: 'I want sharper memory and recall',
        slots: [
          { primary: 'lions-mane-mushroom', swaps: ['mushroom-complex-10-x', 'fermented-mushroom-blend'] },
          { primary: 'brain-focus-formula', swaps: ['cognitive-support', 'ginkgo-biloba-ginseng'] },
          { primary: 'nad',                 swaps: ['methylene-blue-drops', 'focus-powder-sour-grape'] },
        ]
      },
      {
        label: 'I need sustained focus for deep work',
        slots: [
          { primary: 'focus-powder-sour-grape', swaps: ['brain-focus-formula', 'energy-strips'] },
          { primary: 'ashwagandha',             swaps: ['ashwagandha-plus', 'cognitive-relax-strips'] },
          { primary: 'lions-mane-mushroom',     swaps: ['ginkgo-biloba-ginseng', 'cognitive-support'] },
        ]
      },
    ]
  },

  sleep: {
    label: 'Sleep & Recovery',
    icon: '🌙',
    color: 'rgba(100,120,255,.6)',
    intro: 'Restorative formulas for deeper sleep, faster muscle repair, and genuine daily recovery.',
    symptoms: [
      {
        label: 'I can\'t fall asleep or stay asleep',
        slots: [
          { primary: 'sleep-formula',       swaps: ['sleep-support', 'cognitive-relax-strips'] },
          { primary: 'magnesium-glycinate', swaps: ['ashwagandha', '5-htp'] },
          { primary: 'ashwagandha-plus',    swaps: ['omega-3-epa-180mg-dha-120mg', 'lions-mane-mushroom'] },
        ]
      },
      {
        label: 'I wake up feeling unrested',
        slots: [
          { primary: 'magnesium-glycinate', swaps: ['sleep-formula', 'sleep-support'] },
          { primary: 'nad',                 swaps: ['coq10-ubiquinone', 'alpha-energy'] },
          { primary: 'ashwagandha',         swaps: ['ashwagandha-plus', '5-htp'] },
        ]
      },
      {
        label: 'My muscles are sore and slow to recover',
        slots: [
          { primary: 'bcaa-post-workout-powder-honeydew-watermelon', swaps: ['bcaa-shock-powder-fruit-punch', 'l-glutamine-powder'] },
          { primary: 'creatine-monohydrate',                         swaps: ['creatine-hydration-powder', 'colostrum-capsules'] },
          { primary: 'grass-fed-hydrolyzed-collagen-peptides',       swaps: ['colostrum-powder', 'platinum-turmeric'] },
        ]
      },
      {
        label: 'I need to dial down stress before bed',
        slots: [
          { primary: 'ashwagandha-plus',    swaps: ['ashwagandha', 'cognitive-relax-strips'] },
          { primary: 'sleep-formula',       swaps: ['sleep-support', '5-htp'] },
          { primary: 'magnesium-glycinate', swaps: ['l-glutamine-powder', 'omega-3-epa-180mg-dha-120mg'] },
        ]
      },
    ]
  },

  body: {
    label: 'Body & Performance',
    icon: '🔥',
    color: 'rgba(255,100,60,.6)',
    intro: 'Science-backed compounds for muscle, endurance, body composition, and hormonal vitality.',
    symptoms: [
      {
        label: 'I want to build muscle and strength',
        slots: [
          { primary: 'creatine-monohydrate',                      swaps: ['creatine-hydration-powder', 'bcaa-shock-powder-fruit-punch'] },
          { primary: 'advanced-100-whey-protein-isolate-chocolate',swaps: ['plant-protein-chocolate', 'colostrum-capsules'] },
          { primary: 'energy-powder-fruit-punch',                 swaps: ['nitric-shock-pre-workout-powder-fruit-punch', 'l-citrulline-l-arginine-stack'] },
        ]
      },
      {
        label: 'I\'m trying to lose body fat',
        slots: [
          { primary: 'berberine',                                 swaps: ['fat-burner-with-mct', 'normal-blood-sugar-support'] },
          { primary: 'greens-superfood',                          swaps: ['fruits-and-veggies', 'moringa-pure'] },
          { primary: 'advanced-100-whey-protein-isolate-chocolate',swaps: ['plant-protein-chocolate', 'l-glutamine-powder'] },
        ]
      },
      {
        label: 'I need better workout fuel and endurance',
        slots: [
          { primary: 'energy-powder-fruit-punch',  swaps: ['nitric-shock-pre-workout-powder-fruit-punch', 'energy-strips'] },
          { primary: 'creatine-hydration-powder',  swaps: ['hydration-powder-lemonade', 'bcaa-shock-powder-fruit-punch'] },
          { primary: 'nitric-oxide',               swaps: ['l-citrulline-l-arginine-stack', 'beetroot-powder'] },
        ]
      },
      {
        label: 'My hormones feel off',
        slots: [
          { primary: 'mens-vitality',     swaps: ['womens-vitality-formula', 'alpha-energy'] },
          { primary: 'ashwagandha-plus',  swaps: ['maca-plus', 'horny-goat-weed-blend'] },
          { primary: 'nad',               swaps: ['resveratrol-50-600mg', 'coq10-ubiquinone'] },
        ]
      },
    ]
  },

  longevity: {
    label: 'Longevity & Beauty',
    icon: '✨',
    color: 'rgba(212,168,67,.8)',
    intro: 'Advanced compounds targeting cellular aging, skin vitality, and the science of living longer.',
    symptoms: [
      {
        label: 'I want to slow visible aging',
        slots: [
          { primary: 'nad',                                       swaps: ['methylene-blue-drops', 'resveratrol-50-600mg'] },
          { primary: 'grass-fed-hydrolyzed-collagen-peptides',    swaps: ['beauty-collagen-strips', 'grass-fed-collagen-peptides-powder-chocolate'] },
          { primary: 'platinum-turmeric',                         swaps: ['omega-3-epa-180mg-dha-120mg', 'sea-moss'] },
        ]
      },
      {
        label: 'My hair, skin, or nails need support',
        slots: [
          { primary: 'hair-skin-and-nails-essentials',            swaps: ['hair-skin-and-nails-strips', 'beauty-collagen-strips'] },
          { primary: 'grass-fed-hydrolyzed-collagen-peptides',    swaps: ['grass-fed-collagen-peptides-powder-chocolate', 'grass-fed-collagen-creamer-vanilla'] },
          { primary: 'omega-3-epa-180mg-dha-120mg',               swaps: ['sea-moss', 'platinum-turmeric'] },
        ]
      },
      {
        label: 'I want cellular and DNA-level protection',
        slots: [
          { primary: 'nad',                    swaps: ['methylene-blue-drops', 'alpha-energy'] },
          { primary: 'resveratrol-50-600mg',   swaps: ['platinum-turmeric', 'omega-3-epa-180mg-dha-120mg'] },
          { primary: 'fermented-mushroom-blend',swaps: ['mushroom-complex-10-x', 'lions-mane-mushroom'] },
        ]
      },
      {
        label: 'I want a complete anti-aging daily protocol',
        slots: [
          { primary: 'nad',                                       swaps: ['methylene-blue-drops', 'resveratrol-50-600mg'] },
          { primary: 'grass-fed-hydrolyzed-collagen-peptides',    swaps: ['beauty-collagen-strips', 'grass-fed-collagen-peptides-powder-chocolate'] },
          { primary: 'hair-skin-and-nails-essentials',            swaps: ['fermented-mushroom-blend', 'sea-moss'] },
        ]
      },
    ]
  }
};

// =============================================
// STATE
// =============================================
let vssCurrentGoal     = null;
let vssCurrentSymptom  = null;
let vssSlotState       = [null, null, null]; // current handle per slot
let vssRemovedSlots    = [false, false, false];

// =============================================
// INIT
// =============================================
document.addEventListener('DOMContentLoaded', function() {
  vssRenderGoals();
});

// =============================================
// STEP 1 — RENDER GOAL CARDS
// =============================================
function vssRenderGoals() {
  const wrap = document.getElementById('vss-goals-grid');
  if (!wrap) return;
  wrap.innerHTML = '';
  Object.entries(VSS_STACKS).forEach(([key, goal]) => {
    const card = document.createElement('button');
    card.className = 'vss-goal-card';
    card.setAttribute('data-goal', key);
    card.innerHTML = `
      <span class="vss-goal-icon">${goal.icon}</span>
      <span class="vss-goal-label">${goal.label}</span>
      <span class="vss-goal-card-arrow">Select →</span>
    `;
    card.addEventListener('click', () => vssSelectGoal(key));
    wrap.appendChild(card);
  });
}

// =============================================
// STEP 2 — SELECT GOAL → SHOW SYMPTOMS
// =============================================
function vssSelectGoal(goalKey) {
  vssCurrentGoal = goalKey;
  vssCurrentSymptom = null;
  const goal = VSS_STACKS[goalKey];

  // Update goal card active state
  document.querySelectorAll('.vss-goal-card').forEach(c => {
    c.classList.toggle('active', c.getAttribute('data-goal') === goalKey);
  });

  // Show symptom step, hide stack
  document.getElementById('vss-symptom-step').style.display = 'block';
  document.getElementById('vss-stack-step').style.display   = 'none';

  // Scroll to symptom step
  document.getElementById('vss-symptom-step').scrollIntoView({ behavior: 'smooth', block: 'start' });

  // Render intro + symptom buttons
  document.getElementById('vss-symptom-goal-name').textContent = goal.label;
  document.getElementById('vss-symptom-intro').textContent     = goal.intro;

  const list = document.getElementById('vss-symptom-list');
  list.innerHTML = '';
  goal.symptoms.forEach((sym, idx) => {
    const btn = document.createElement('button');
    btn.className = 'vss-symptom-btn';
    btn.textContent = sym.label;
    btn.addEventListener('click', () => vssSelectSymptom(idx));
    list.appendChild(btn);
  });
}

// =============================================
// STEP 3 — SELECT SYMPTOM → RENDER STACK
// =============================================
function vssSelectSymptom(symIdx) {
  vssCurrentSymptom = symIdx;
  const goal = VSS_STACKS[vssCurrentGoal];
  const sym  = goal.symptoms[symIdx];

  // Update symptom button active state
  document.querySelectorAll('.vss-symptom-btn').forEach((b, i) => {
    b.classList.toggle('active', i === symIdx);
  });

  // Init slot state to primaries
  vssSlotState    = sym.slots.map(s => s.primary);
  vssRemovedSlots = [false, false, false];

  // Show stack step
  document.getElementById('vss-stack-step').style.display = 'block';
  document.getElementById('vss-stack-step').scrollIntoView({ behavior: 'smooth', block: 'start' });

  vssRenderStack();
  // Pre-fetch availability for all slot products (re-renders when done)
  vssPrefetchAvailability();
}

// =============================================
// RENDER STACK CARDS
// =============================================
function vssGetBuyButton(handle) {
  const avail = window.VSS_AVAILABILITY ? window.VSS_AVAILABILITY[handle] : undefined;
  if (avail === false) {
    return `<span class="vss-buy-btn out-of-stock">Out of Stock</span>`;
  }
  return `<button class="vss-buy-btn" onclick="vssAddOneToCart('${handle}', this)">Add to Cart</button>`;
}

function vssRenderStack() {
  const goal  = VSS_STACKS[vssCurrentGoal];
  const sym   = goal.symptoms[vssCurrentSymptom];
  const wrap  = document.getElementById('vss-cards-wrap');
  wrap.innerHTML = '';

  sym.slots.forEach((slot, idx) => {
    const handle  = vssSlotState[idx];
    const product = VSS_PRODUCTS[handle];
    const removed = vssRemovedSlots[idx];
    const card    = document.createElement('div');
    card.className = 'vss-card' + (removed ? ' removed' : '');
    card.id = `vss-card-${idx}`;

    if (removed) {
      card.innerHTML = `
        <div class="vss-card-removed-msg">
          <span>${product.name}</span>
          <span class="vss-removed-label">Removed</span>
        </div>
        <button class="vss-restore-btn" onclick="vssRestoreSlot(${idx})">↩ Restore</button>
      `;
    } else {
      // Build swap options:
      // - If current handle IS the primary, show the defined swap pool
      // - If current handle is a swap, inject the original primary first so customer can swap back
      // - Always exclude the currently displayed handle
      const currentIsPrimary = handle === slot.primary;
      const swapPool = currentIsPrimary
        ? slot.swaps
        : [slot.primary, ...slot.swaps.filter(h => h !== handle)];
      const swapOptions = swapPool.filter(h => h !== handle);

      const swapBtns = swapOptions.map(swapHandle => {
        const sp = VSS_PRODUCTS[swapHandle];
        return `<button class="vss-swap-btn" onclick="vssSwapSlot(${idx}, '${swapHandle}')">
          ⇄ Swap for ${sp ? sp.name : swapHandle}
        </button>`;
      }).join('');

      card.innerHTML = `
        <div class="vss-card-inner">
          <div class="vss-card-top">
            <span class="vss-slot-num">0${idx + 1}</span>
            <button class="vss-remove-btn" onclick="vssRemoveSlot(${idx})">✕ Remove</button>
          </div>
          <div class="vss-card-name">${product.name}</div>
          <div class="vss-card-price">$${product.price.toFixed(2)}</div>
          <div class="vss-card-actions">
            ${vssGetBuyButton(handle)}
            ${swapBtns}
          </div>
        </div>
      `;
    }
    wrap.appendChild(card);
  });

  vssUpdateSummary();
}

// =============================================
// SLOT INTERACTIONS
// =============================================
function vssRemoveSlot(idx) {
  vssRemovedSlots[idx] = true;
  vssRenderStack();
}

function vssRestoreSlot(idx) {
  vssRemovedSlots[idx] = false;
  vssRenderStack();
}

function vssSwapSlot(idx, newHandle) {
  vssSlotState[idx] = newHandle;
  vssRenderStack();
  // Fetch availability for the swapped-in product if not already cached
  if (window.VSS_AVAILABILITY[newHandle] === undefined) {
    vssCheckAvailability(newHandle).then(() => vssRenderStack());
  }
}

// =============================================
// SUMMARY BAR
// =============================================
function vssUpdateSummary() {
  const goal = VSS_STACKS[vssCurrentGoal];
  const sym  = goal.symptoms[vssCurrentSymptom];

  let total = 0;
  let count = 0;
  sym.slots.forEach((slot, idx) => {
    if (!vssRemovedSlots[idx]) {
      const p = VSS_PRODUCTS[vssSlotState[idx]];
      if (p) { total += p.price; count++; }
    }
  });

  const totalEl = document.getElementById('vss-total-price');
  const countEl = document.getElementById('vss-item-count');
  const summaryEl = document.getElementById('vss-summary');

  if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
  if (countEl) countEl.textContent = count + (count === 1 ? ' item' : ' items');
  if (summaryEl) summaryEl.style.display = count > 0 ? 'flex' : 'none';
}

// =============================================
// SHOPIFY CART API — SUPPLEMENT STACK
// =============================================

window.VSS_AVAILABILITY = window.VSS_AVAILABILITY || {};
window.VSS_VARIANT_IDS  = window.VSS_VARIANT_IDS  || {};

async function vssCheckAvailability(handle) {
  if (window.VSS_AVAILABILITY[handle] !== undefined) return;
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) { window.VSS_AVAILABILITY[handle] = false; return; }
    const data = await res.json();
    const availVariant = data.variants.find(v => v.available);
    const firstVariant = data.variants[0];
    if (availVariant) {
      window.VSS_AVAILABILITY[handle] = true;
      window.VSS_VARIANT_IDS[handle]  = availVariant.id;
    } else if (firstVariant) {
      window.VSS_AVAILABILITY[handle] = false;
      window.VSS_VARIANT_IDS[handle]  = firstVariant.id;
    } else {
      window.VSS_AVAILABILITY[handle] = false;
    }
  } catch(e) { window.VSS_AVAILABILITY[handle] = false; }
}

// Pre-fetch availability for all slots in current stack, re-render when done
async function vssPrefetchAvailability() {
  const goal = VSS_STACKS[vssCurrentGoal];
  if (!goal) return;
  const sym = goal.symptoms[vssCurrentSymptom];
  if (!sym) return;
  const promises = sym.slots.map((slot, idx) => {
    const handle = vssSlotState[idx] || slot.primary;
    return vssCheckAvailability(handle);
  });
  await Promise.all(promises);
  vssRenderStack();
}

async function vssAddOneToCart(handle, btn) {
  const orig = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  let variantId = window.VSS_VARIANT_IDS[handle];
  if (!variantId) {
    await vssCheckAvailability(handle);
    variantId = window.VSS_VARIANT_IDS[handle];
  }
  if (!variantId) {
    btn.textContent = 'Unavailable';
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
    return;
  }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (res.ok) {
      btn.textContent = '✓ Added';
      btn.style.background = 'rgba(100,200,100,.15)';
      btn.style.color = 'rgba(100,200,100,.9)';
      btn.style.border = '1px solid rgba(100,200,100,.3)';
      setTimeout(() => {
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.style.border = '';
        btn.disabled = false;
      }, 2000);
    } else {
      btn.textContent = 'Error — Try Again';
      btn.disabled = false;
    }
  } catch(e) {
    btn.textContent = 'Error — Try Again';
    btn.disabled = false;
  }
}

async function vssAddStackToCart() {
  const btn = document.getElementById('vss-checkout-btn');
  const noteEl = document.getElementById('vssSkippedNote');
  if (!btn) return;
  btn.textContent = 'Building Your Cart...';
  btn.disabled = true;
  if (noteEl) noteEl.style.display = 'none';

  const goal = VSS_STACKS[vssCurrentGoal];
  const sym  = goal.symptoms[vssCurrentSymptom];
  const toAdd = [];
  const skipped = [];

  sym.slots.forEach((slot, idx) => {
    if (vssRemovedSlots[idx]) return;
    const handle = vssSlotState[idx];
    const product = VSS_PRODUCTS[handle];
    if (!product) return;
    const avail = window.VSS_AVAILABILITY[handle];
    if (avail === false) {
      skipped.push(product.name + ' (Out of Stock)');
      return;
    }
    toAdd.push(handle);
  });

  if (toAdd.length === 0) {
    btn.textContent = 'Add Stack to Cart →';
    btn.disabled = false;
    if (noteEl) {
      noteEl.textContent = 'Selected items are currently out of stock — try swapping for alternatives.';
      noteEl.style.display = 'block';
    }
    return;
  }

  const items = toAdd
    .map(h => window.VSS_VARIANT_IDS[h])
    .filter(id => id)
    .map(id => ({ id, quantity: 1 }));

  if (items.length === 0) {
    btn.textContent = 'Could Not Add — Try Again';
    btn.disabled = false;
    return;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (res.ok) {
      if (skipped.length > 0 && noteEl) {
        noteEl.textContent = skipped.length + ' item(s) not added: ' + skipped.join(', ') + '.';
        noteEl.style.display = 'block';
        setTimeout(() => { window.location.href = '/cart'; }, 2000);
      } else {
        window.location.href = '/cart';
      }
    } else {
      btn.textContent = 'Error — Try Again';
      btn.disabled = false;
    }
  } catch(e) {
    btn.textContent = 'Error — Try Again';
    btn.disabled = false;
  }
}